/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 } from './';
import {
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSON,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSONTyped,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1ToJSON,
} from './';
import type { InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2 } from './';
import {
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSON,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSONTyped,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2ToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseCompanyMostActiveMembers
 */
export interface InvitationContextResponseEnterpriseCompanyMostActiveMembers {
    /**
     * 
     * @type {InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1}
     * @memberof InvitationContextResponseEnterpriseCompanyMostActiveMembers
     */
    member1?: InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1;
    /**
     * 
     * @type {InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2}
     * @memberof InvitationContextResponseEnterpriseCompanyMostActiveMembers
     */
    member2?: InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseCompanyMostActiveMembers interface.
 */
export function instanceOfInvitationContextResponseEnterpriseCompanyMostActiveMembers(value: object): value is InvitationContextResponseEnterpriseCompanyMostActiveMembers {
    return true;
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSON(json: any): InvitationContextResponseEnterpriseCompanyMostActiveMembers {
    return InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseCompanyMostActiveMembers {
    if (json == null) {
        return json;
    }
    return {
        
        'member1': json['member1'] == null ? undefined : InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSON(json['member1']),
        'member2': json['member2'] == null ? undefined : InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2FromJSON(json['member2']),
    };
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersToJSON(value?: InvitationContextResponseEnterpriseCompanyMostActiveMembers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'member1': InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1ToJSON(value['member1']),
        'member2': InvitationContextResponseEnterpriseCompanyMostActiveMembersMember2ToJSON(value['member2']),
    };
}

